import api from "../../api.js";

export async function getPractitionerTypes() {
  const res = await api.get("/api/practitioners/types");
  return res.data?.data || [];
}

export async function listPractitioners() {
  const res = await api.get("/api/practitioners");
  return res.data?.data || [];
}

export async function getPractitioner(practitionerId) {
  const res = await api.get(`/api/practitioners/${encodeURIComponent(practitionerId)}`);
  return res.data?.data || null;
}

export async function setPractitionerEnabled(practitionerId, enabled) {
  const res = await api.patch(`/api/practitioners/${encodeURIComponent(practitionerId)}/enabled`, { enabled });
  return res.data;
}

export async function createPractitioner(payload) {
  try {
    const res = await api.post("/api/practitioners", payload);
    return res.data;
  } catch (err) {
    const msg = err?.message || "Failed to save";
    throw new Error(msg.includes("409") ? "Practice number already exists" : msg);
  }
}

export async function updatePractitioner(practitionerId, payload) {
  try {
    const res = await api.patch(`/api/practitioners/${encodeURIComponent(practitionerId)}`, payload);
    return res.data;
  } catch (err) {
    const msg = err?.message || "Failed to update";
    throw new Error(msg.includes("409") ? "Practice number already exists" : msg);
  }
}